<template>
  <nav id="navbar" class="flex items-center justify-between flex-wrap text-white bg-gray-700 pr-4 pl-4 border-b-4 border-pink-500">
    <div class="flex h-full items-center mr-4">
      <div class="h-full p-2">
        <img class="h-full mr-2" src="../assets/logo.png" alt="">
      </div>
      <span class="font-semibold text-xl tracking-tight">
        Geospatial exploration
      </span>
    </div>
    <div class="h-full flex flex-grow items-center justify-between">
      <div class="text-sm text-purple-200">
        <!-- <a href="#" class="hover:text-white mr-4">Docs</a>
        <a href="#" class="hover:text-white mr-4">Examples</a>
        <a href="#" class="hover:text-white mr-4">Blog</a> -->
      </div>
      <div class="flex">
        <div>
          <div class="inline-block select-none" @click="open = !open">
            <span class="appearance-none flex items-center inline-block text-sm px-4 py-1 border rounded hover:bg-white hover:text-gray-700 hover:border-transparent">
              <span class="mr-1">Download</span>
              <svg class="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </span>
          </div>
          <div class="absolute mr-4 right-0 mt-px" style="z-index: 50" v-show="open" data-html2canvas-ignore>
            <div class="bg-white shadow rounded border overflow-hidden">
              <button
                @click=downloadMap()
                class="w-full no-underline block px-4 py-3 border-t text-black bg-white whitespace-no-wrap hover:bg-gray-700 hover:text-white">
                PNG
              </button>
              <button
                @click=downloadGeojson()
                class="w-full no-underline block px-4 py-3 border-t text-black bg-white whitespace-no-wrap hover:bg-gray-700 hover:text-white">
                Map as GeoJSON
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import html2canvas from 'html2canvas';
import canvg from 'canvg';
import * as FileSaver from 'file-saver';
import { EventBus } from '../event-bus';

export default {
  name: 'TopNav',
  data() {
    return {
      geojson: null,
      open: false,
      testOptions: [ 'Map Capture', 'Geojson' ]
    };
  },
  methods: {
    closeDropdown() {
      this.open = false;
    },
    async downloadMap() {
      this.closeDropdown();
      const tempLegendCanvas = document.querySelector('#tempLegendCanvas');
      const svgLegend = document.querySelector('#legendSvg');
      const xml = (new XMLSerializer()).serializeToString(svgLegend);
      tempLegendCanvas.classList.remove('hidden');
      svgLegend.classList.add('hidden');
      canvg(tempLegendCanvas, xml);
      const canvasRenderParams = {
        allowTainted: true,
        useCORS: true,
        foreignObjectRendering: true,
        ignoreElements: element => (
          element.classList.contains('leaflet-control-zoom') ||
          element.classList.contains('leaflet-popup')
        )
      };
      const canvas = await html2canvas(document.querySelector('#map-container'), canvasRenderParams);
      canvas.toBlob((blob) => {
        FileSaver.saveAs(blob, 'map.png');
        svgLegend.classList.remove('hidden');
        tempLegendCanvas.classList.add('hidden');
        tempLegendCanvas.getContext('2d').clearRect(0, 0, tempLegendCanvas.width, tempLegendCanvas.height);
      });
    },
    downloadGeojson() {
      this.closeDropdown();
      const blob = new Blob([JSON.stringify(this.geojson)], {type: "application/json"});
      FileSaver.saveAs(blob, "result.json");
    },
    setupEvents() {
      const that = this;
      EventBus.$on('geojsonLoad', (geojson) => {
        that.geojson = geojson;
      });
    }
  },
  mounted() {
    this.setupEvents();
  }
};
</script>

<style lang="stylus">
  #navbar
    height 48px
</style>
